/* src/app/settlement/list-settlement/list-settlement.component.css */
:host ::ng-deep .p-chip-md {
  font-size: 1rem;
  padding: 0.5rem 0.75rem;
}
:host ::ng-deep .p-chip-md .p-chip-image {
  width: 2rem;
  height: 2rem;
  margin-right: 0.5rem;
}
:host ::ng-deep .p-chip-md .p-chip-icon {
  font-size: 1.5rem;
  margin-right: 0.5rem;
}
/*# sourceMappingURL=list-settlement.component-OTVQ4VSA.css.map */
